import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import AnimatedElement from './AnimatedElement';
import { useCms, useSection } from '../context/CmsContext';

const EventsSection = () => {
  const veranstaltungen = useSection('veranstaltungen');
  const { events } = useCms();
  const months = events.months || [];

  const tableStyles = {
    width: '100%',
    borderCollapse: 'separate',
    borderSpacing: { xs: '0 6px', md: '0 8px' },
    '& tr': {
      backgroundColor: 'rgba(255,255,255,0.05)',
      transition: '0.2s ease',
      '&:hover': {
        backgroundColor: 'rgba(255,255,255,0.1)',
      },
    },
    '& td': {
      color: '#fff',
      fontSize: { xs: '0.82rem', sm: '0.9rem', md: '1rem' },
      padding: { xs: '8px 8px', sm: '10px 10px', md: '10px 12px' },
      verticalAlign: 'top',
      overflowWrap: 'anywhere',
    },
    '& td:first-of-type': {
      fontWeight: 600,
      width: { xs: '52px', sm: '70px' },
      borderRight: '1px solid rgba(255,255,255,0.2)',
    },
    '& td:nth-of-type(2)': {
      fontWeight: 600,
      width: { xs: '42px', sm: '60px' },
      borderRight: '1px solid rgba(255,255,255,0.2)',
      opacity: 0.9,
    },
    '& td:nth-of-type(3)': {
      fontWeight: 400,
    },
  };


  return (
    <Box
      id="veranstaltungen"
      sx={{
        py: { xs: 8, md: 12 },
        bgcolor: 'primary.green',
      }}
    >

      <Container maxWidth={false} sx={{ maxWidth: '1400px', mx: 'auto', px: 2 }}>

        {/* HEADER */}
        <AnimatedElement>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: '1fr auto' },
              alignItems: 'end',
              mb: { xs: 6, md: 10 },
            }}
          >
            <Box>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: '1.6rem', md: '2.2rem' },
                  fontWeight: 500,
                  color: '#fff',
                }}
              >
                {veranstaltungen.heading}
              </Typography>

              <Box
                sx={{
                  height: '4px',
                  width: '100px',
                  backgroundColor: '#cfba80',
                  mt: 2,
                }}
              />
            </Box>

            <Typography
              sx={{
                display: { xs: 'none', md: 'block' },
                color: '#fff',
                letterSpacing: '0.2em',
                writingMode: 'vertical-rl',
                textOrientation: 'mixed',
                opacity: 0.8,
              }}
            >
              {veranstaltungen.label}
            </Typography>
          </Box>
        </AnimatedElement>

        {/* EVENTS GRID */}
        <AnimatedElement>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                sm: '1fr 1fr',
                md: '1fr 1fr 1fr 1fr',
              },
              gap: 4,
              rowGap: { xs: 3, md: 4 },
            }}
          >
            {months.map((month, index) => (
              <Box key={month.id || index}>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { xs: '1.6rem', md: '2rem' },
                    fontWeight: 500,
                    color: 'primary.beige',
                    mb: 2,
                  }}
                >
                  {month.title}
                </Typography>

                <Box component="table" sx={tableStyles}>
                  <tbody>
                    {(month.entries || []).map((entry, entryIndex) => (
                      <tr key={entryIndex}>
                        <td>{entry.day}</td>
                        <td>{entry.weekday}</td>
                        <td>{entry.text}</td>
                      </tr>
                    ))}
                  </tbody>
                </Box>
              </Box>
            ))}
          </Box>
        </AnimatedElement>

      </Container>
    </Box>
  );
};

export default EventsSection;
